// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:18:11+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            8fec4ad4fe5c5b767d4627a91fe42ccd
//    Signature:      eyJpdiI6IjZxNUZCMXVJejBiZlRVb1RMVXVTYnc9PSIsInZhbHVlIjoiYk1WMUF5YUVEaElKbnZ2cnJIMjFkUU80cHY3TW5ndGFHU2RaZ0NFMXZHdTJ1RzlxcXVXS2F4Q2I5VjdGVzVsZWFWXC8wR3V1VStkdmNxZFlocmhCQTRuSlR5MDdPc1ZVZXZvVnZBWHlKXC9HWEZPS1JsNGpOWjFmZ1hHelBPR2g0S0pYUUZmMHdUcnl5a1wvSFJ2cE1mZkVHdkhtSnNKNWZ2aENCM2xLaUVuZTVHaVVHclFwN3JRdHZRYjhERlwvaWtDSkNxaWxjTkZaVTJ0dU1xT2FKRDRRZDlHS2VJM2hBNFVuUjQ1Y0pOZk1RMHVsa0RqdElJMXAyRUQySlJTaFJzZWl4M3d2UzU3S095VDIwVlZWSHphYmI0U2hwRUtzVTVwN2JVblpGTG94b0JcL3VRU3JBUnJIMVlkT25sbnlZK01uclVrZDVVSUpHXC84V1dRUm5lcXJtaEVTamJKVTJWUlhtVWk0ZDNzXC9HblRtdEFcL0xxRTZpM09NZjBMUXN5dzJqT3NWSW1PVmtCMkxXaGg0ZVZ6T2huNFwvVDA3ekQ5MWc4VWt3VlhuSGR0MmU5TT0iLCJtYWMiOiJhOGIyMjJmODEwZDFjMWI4Zjg0ZmM4ZjJmZWFkMmFiYzUzYTNjZDcxODYxNzA3M2I0NmVjMTc5OTlhODgxZWQ4In0=
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
